export default __webpack_public_path__ + "static/media/treegraphic_fake.df7e0752.png";